import React from 'react';
export function StorySection() {
  return <section className="py-16 px-4 bg-white" data-id="element-139">
      <div className="max-w-4xl mx-auto" data-id="element-140">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-141">
          LA HISTORIA QUE INICIÓ TODO
        </h2>

        <div className="bg-gradient-to-br from-rose-50 to-orange-50 p-8 md:p-12 rounded-2xl shadow-lg" data-id="element-142">
          <div className="prose prose-lg max-w-none" data-id="element-143">
            <p className="text-xl text-gray-800 leading-relaxed mb-6" data-id="element-144">
              Llegué a EE.UU. deseando que mis hijos fueran bilingües. Pero un
              día, mi hijo —que ya casi no hablaba español— me miró y dijo:
            </p>

            <blockquote className="border-l-4 border-rose-500 pl-6 my-8 italic text-2xl text-gray-900 font-semibold" data-id="element-145">
              "Mom… don't speak Spanish."
            </blockquote>

            <p className="text-xl text-gray-800 leading-relaxed mb-6" data-id="element-146">
              Ese día lloré en el carro. Sentía que estaba perdiendo mi idioma…
              pero sobre todo,{' '}
              <span className="font-bold text-rose-600" data-id="element-147">
                estaba perdiendo una parte de mí.
              </span>
            </p>

            <p className="text-xl text-gray-800 leading-relaxed mb-6" data-id="element-148">
              Decidí cambiarlo. Investigando, probando, ajustando… encontré la
              clave:
            </p>

            <div className="bg-amber-100 p-6 rounded-lg text-center my-8" data-id="element-149">
              <p className="text-2xl font-bold text-gray-900" data-id="element-150">
                El español no se enseña. El español se siente.
              </p>
            </div>

            <p className="text-xl text-gray-800 leading-relaxed font-semibold" data-id="element-151">
              Cambié la emoción. El idioma regresó. Y ahora esta transformación
              está en tus manos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}